<template>
  <div class="text-field-container">
    <input
      type="text"
      class="text-input"
      size="1"
      :style="{ textAlign: textAlign }"
      :value="value"
      @input="updateValue($event.target.value)"
    />
    <span class="unit-label">{{ unit }}</span>
  </div>
</template>

<script>
export default {
  name: 'TextField',
  props: {
    textAlign: {
      default: 'right'
    },
    unit: {
      default: 'inches'
    },
    value: {
      default: NaN
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>
.text-field-container {
  display: flex;
  flex-direction: row;
  background: #ffffff;
  border: 1px solid #373737;
}
.text-input {
  flex-grow: 1;
  border: none;
  font-size: inherit;
  margin: 0;
}
.text-input:focus {
  outline-width: 0;
}
.unit-label {
  box-sizing: border-box;
  flex-grow: 0;
  padding-left: 0.5%;
  padding-right: 1.7%;
  color: #d3d3d3;
}
</style>
